import api from "../api";

export interface VehicleCheckData {
  make: string | null;
  model: string | null;
  year: number | null;
  vin: string | null;
  colour: string | null;
  fuel_type: string | null;
  vehicle_category: string;
  body_type: string;
  cached: boolean;
  mot_status?: string;
  mot_expiry_date?: string;
  tax_status?: string;
  tax_due_date?: string;
  class?: string;
  number_of_axles?: number;
  weight?: number;
  wheel_base?: string;
  transmission?: string;
  vehicle_image_url?: string;
}

export interface VehicleCheckResponse {
  success: boolean;
  data?: VehicleCheckData;
  message?: string;
}

class VehicleCheckService {
  async checkVehicle(
    registrationNumber: string
  ): Promise<VehicleCheckResponse> {
    try {
      const response = await api.post("/vehicle-check", {
        registration_number: registrationNumber,
      });
      return response.data;
    } catch (error: any) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          "Failed to check vehicle registration. Please try again.",
      };
    }
  }
}

export default new VehicleCheckService();
